// Entry della libreria: registra i custom element solo dopo che
// la configurazione runtime e le traduzioni sono state scaricate e applicate.

export * from './event-config-service';
export * from './utils/cta';
export * from './utils/google-maps';
export * from './utils/map';
export * from './utils/timezone';
export { translationsReady } from './translation-service';

// Both config and translations start downloading immediately and in parallel.
// Custom elements are defined only after both are ready so that the very first
// render already has the correct config and strings applied.
import { configReady } from './event-config-service';
import { translationsReady } from './translation-service';
import { ensureNodeEnvDefault } from './utils/host-config';

ensureNodeEnvDefault('production');

setTimeout(() => {
  Promise.all([configReady, translationsReady]).then(() => {
    import('./search-page');
    import('./store-detail-overlay');
  });
}, 100);
